'use client';

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  // Check if this is an environment validation error
  const isEnvError = error?.message?.includes('Environment validation failed');
  const isDevelopment = process.env.NODE_ENV === 'development';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        padding: '2rem',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        backgroundColor: '#f5f5f5',
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          padding: '3rem',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          maxWidth: '600px',
          width: '100%',
        }}
      >
        <h1
          style={{
            fontSize: '2rem',
            marginBottom: '1rem',
            color: isEnvError ? '#d32f2f' : '#333',
          }}
        >
          {isEnvError ? 'Configuration Error' : 'Application Error'}
        </h1>

        {isEnvError ? (
          <>
            <p style={{ marginBottom: '1.5rem', color: '#666', lineHeight: '1.5' }}>
              BabyPortal cannot start because required configuration is missing.
            </p>

            <div
              style={{
                backgroundColor: '#fff3cd',
                border: '1px solid #ffeaa7',
                borderRadius: '4px',
                padding: '1rem',
                marginBottom: '2rem',
                textAlign: 'left',
              }}
            >
              <p style={{ margin: 0, color: '#856404', fontSize: '0.875rem' }}>
                <strong>Required Environment Variables:</strong>
              </p>
              <ul
                style={{
                  marginTop: '0.5rem',
                  marginBottom: 0,
                  paddingLeft: '1.5rem',
                  color: '#856404',
                  fontSize: '0.875rem',
                }}
              >
                <li>SESSION_SECRET (32+ characters)</li>
                <li>NEXT_PUBLIC_MEDPLUM_BASE_URL</li>
                <li>NEXT_PUBLIC_MEDPLUM_CLIENT_ID</li>
                <li>NEXT_PUBLIC_MEDPLUM_PROJECT_ID</li>
                <li>NEXT_PUBLIC_APP_URL</li>
              </ul>
              <p
                style={{
                  margin: '0.75rem 0 0 0',
                  color: '#856404',
                  fontSize: '0.75rem',
                }}
              >
                Configure these in AWS Amplify Environment Variables.
              </p>
            </div>

            {isDevelopment && (
              <details
                style={{
                  textAlign: 'left',
                  marginBottom: '2rem',
                  fontSize: '0.875rem',
                  color: '#666',
                }}
              >
                <summary style={{ cursor: 'pointer', marginBottom: '0.5rem' }}>Full error details</summary>
                <pre
                  style={{
                    backgroundColor: '#f5f5f5',
                    padding: '1rem',
                    borderRadius: '4px',
                    overflow: 'auto',
                    fontSize: '0.75rem',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                  }}
                >
                  {error.message}
                </pre>
              </details>
            )}
          </>
        ) : (
          <>
            <p style={{ marginBottom: '2rem', color: '#666' }}>A critical error occurred during application startup.</p>
            {isDevelopment && error.message && (
              <p style={{ marginBottom: '2rem', color: '#999', fontSize: '0.9rem' }}>{error.message}</p>
            )}
          </>
        )}

        <button
          type="button"
          onClick={() => reset()}
          style={{
            display: 'inline-block',
            padding: '0.75rem 1.5rem',
            backgroundColor: isEnvError ? '#666' : '#0066cc',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '1rem',
            cursor: isEnvError ? 'not-allowed' : 'pointer',
            opacity: isEnvError ? 0.6 : 1,
          }}
          disabled={isEnvError}
        >
          {isEnvError ? 'Configuration Required' : 'Try again'}
        </button>
      </div>
    </div>
  );
}
